import React from "react";
import { RCCDropDown } from "react-common-components";
import IComponentDropDown from "react-common-components/dist/components/DropDown/interface";

const DropdownWithBackground: React.FC<IComponentDropDown> = ({children,...props}) => (
	<RCCDropDown
		borderColor="var(--border-color)"
		backgroundColor="var(--input-background-color)"
		{...props}
	>
		{children}
	</RCCDropDown>
);

export default DropdownWithBackground;
